import React from 'react';
import { ListHorizontal } from 'ui/components';
import { SkeletonText } from 'ui/components/skeleton';
import { formatDate } from 'utilities/common';

export const InformationReceiving = ({ data, isLoading }) => {
  const dummy = Array.from({ length: 4 }, (v, i) => i);

  return (
    <section className="border rounded-2 p-3 pt-2 mb-3" id="detail">
      <div className="fw-semibold py-2 border-bottom" style={{ fontSize: 13 }}>
        {isLoading ? (
          <div style={{ width: 250 }}>
            <SkeletonText count={1} />
          </div>
        ) : (
          'Informasi Receiving'
        )}
      </div>
      <div className="row pt-2">
        {isLoading ? (
          dummy?.map((d, i) => (
            <div className="col-12" key={i}>
              <ListHorizontal
                title={<SkeletonText count={1} />}
                content={<SkeletonText count={1} />}
              />
            </div>
          ))
        ) : (
          <>
            <ListHorizontal title="Code" content={data?.code} />
            <ListHorizontal title="Dibuat Oleh" content={data?.created_by} />
            <ListHorizontal
              title="Dibuat Pada"
              content={formatDate(data?.created_at, 'DD/MM/YYYY HH:mm')}
            />

            {data?.received_by && (
              <>
                <ListHorizontal
                  title="Diterima oleh"
                  content={data?.received_by}
                />
                <ListHorizontal
                  title="Tanggal Diterima"
                  content={formatDate(data?.received_at, 'DD/MM/YYYY HH:mm')}
                />
              </>
            )}

            <ListHorizontal
              title="Catatan"
              className="border-bottom-0"
              content={data?.note || '-'}
            />
          </>
        )}
      </div>
    </section>
  );
};
